import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import transverterFn from "i18nData";

import "./HomePage.scss";
import powerBy from "./images/powerBy.png";

export default function About({ resAll }) {
  const language = useSelector((state) => state.language);
  const [strAll, setStrAll] = useState(transverterFn(language)); //写死的翻译数据
  useEffect(() => {
    setStrAll(transverterFn(language));
  }, [language]);
  return (
    <>
      <div className="about_box">
        <div className="about_padding">
          <p className="about_title">{strAll?.AboutTitle}</p>
          <p className="about_content">{resAll?.entProfile}</p>
        </div>
        {/* <div className='power_by'>
                <img src={powerBy} alt='' />
            </div> */}
      </div>
    </>
  );
}
